import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isHardFreemium, isSoftFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { InformationAlertBanner, InformationBannerType } from 'reactApp/ui/InformationAlertBanner/InformationAlertBanner';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FreemiumEndingBanner.css';

const DISCOUNT_TARIFF_ID = 'W256GB_1m_family_features_discount_3m';

const getAnalyticsName = (): string => {
    if (isHardFreemium) {
        return 'mnz_sub_end_soon_unlimited_hard_freemium';
    }
    if (isSoftFreemium) {
        return 'mnz_sub_end_soon_unlimited_soft_freemium';
    }
    return 'mnz_sub_end_soon_unlimited_soft_freemium';
};

const getPaySource = (): string => {
    if (isHardFreemium) {
        return 'mnz_family_unlimited_hard_freemium_banner_sub_end_soon';
    }
    if (isSoftFreemium) {
        return 'mnz_family_unlimited_soft_freemium_banner_sub_end_soon';
    }
    return 'mnz_family_unlimited_soft_freemium_banner_sub_end_soon';
};

export const FreemiumEndingBanner = memo(() => {
    const dispatch = useDispatch();
    const analyticsName = getAnalyticsName();
    const paySource = getPaySource();

    useEffect(() => {
        sendDwh({
            eventCategory: 'banner',
            action: 'show',
            dwhData: {
                name: analyticsName,
            },
            dwh_enabled: true,
        });
    }, [analyticsName]);

    const handleClick = useCallback(async () => {
        sendDwh({
            eventCategory: 'banner',
            action: 'click',
            dwhData: {
                name: analyticsName,
            },
            dwh_enabled: true,
        });
        await productsController.loadProducts();
        dispatch(
            openTariffBuy({
                productId: DISCOUNT_TARIFF_ID,
                paySource,
                title: 'Семейный тариф Mail Space',
            })
        );
    }, [dispatch, analyticsName, paySource]);

    return (
        <div className={styles.wrapper}>
            <InformationAlertBanner
                title="Пробный период подписки заканчивается"
                content={
                    <div className={styles.content}>
                        Продлите её, чтобы сохранить безлимит и другие возможности. Без продления файлы с телефона могут выйти
                        <br />
                        за лимит базовых 8 ГБ. Если это случится, в Почте и Облаке появятся ограничения
                    </div>
                }
                primaryButtonTitle="Продлить со скидкой"
                type={InformationBannerType.info}
                onPrimaryClick={handleClick}
                closable={false}
            />
        </div>
    );
});

FreemiumEndingBanner.displayName = 'FreemiumEndingBanner';
